// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fa-home,body[data-scrolltop=on] .home-icon-color{color:#6cdb72}", ""]);
// Exports
module.exports = exports;
